import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getJob } from 'api/Career';

export const fetchJob = createAsyncThunk(
    'career/fetchJob',
    async params => {
        const response = await getJob(params);
        return response.data;
    },
    {
        condition: (params, { getState }) => {
            const { jobsState } = getState();
            if (jobsState.jobs.hasOwnProperty(params.slug)) return false;
        },
    },
);

const jobsSlice = createSlice({
    name: 'jobsState',
    initialState: {
        jobs: {},
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchJob.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchJob.fulfilled, (state, action) => {
                state.loading = false;
                const newJobKey = action.payload.data.slug;

                const newJob = {
                    [newJobKey]: action.payload.data,
                };

                state.jobs = {
                    ...state.jobs,
                    ...newJob,
                };
            })
            .addCase(fetchJob.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default jobsSlice.reducer;
